import { trigger, animate, transition, style , state} from '@angular/animations';

export const visibilityPanelAnimation =
    // trigger name for attaching this animation to an element using the [@triggerName] syntax
    trigger('visibilityPanelAnimation', [
         transition(':enter', [
		    
	    style({ "opacity": 0  }),
	    animate('0.2s', style({ "opacity": 1 })),
	  ]),
	  transition(':leave', [
	    
	    style({ "opacity": 1  }),
	    animate('0.2s', style({ "opacity": 0 })),
	  ])
    ]);
